var $ = global.jQuery = global.$;
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/themes/base/datepicker.css');
require('jquery-ui/themes/base/all.css');
require('jquery-ui/themes/base/theme.css');
var widgets = require('../lib/widgets');

var Field = require('./Field');

var DateField = Field.extend({
  init: function() {
    var self = this;
    this._super();
    this.$input.datepicker({
      dateFormat: self.$input.data('dateFormat'),
      maxDate: "-16y",
      defaultDate: "-18y",
      yearRange: "-100:+0",
      changeMonth: true,
      changeYear: true,
      hideIfNoPrevNext: true,
      onClose: function(dateText, inst) {
      },
      beforeShow: function(input, inst) {

        inst.dpDiv.addClass('month-year-datepicker');
      }
    });
  },
});

module.exports = DateField;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/DateField.js
// module id = 296
// module chunks = 1